import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const useAuth = () => {
	const TOKEN = localStorage.getItem("PPKTOKEN");
	return !(TOKEN === undefined || TOKEN === null || TOKEN === "");
}

export const ProtectedRoute = () => {
	const isAuth = useAuth();
	return isAuth ? <Outlet /> : <Navigate to="/" />;
};
